import React, { useEffect, useState } from 'react';
import { ScrollText } from 'lucide-react';
import { adminAPI } from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';
import Alert from '../common/Alert';

const AuditLog = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    adminAPI.getAuditLogs({ limit: 200 }).then((r) => {
      if (r.success) setData(r.data);
      else setError(r.message || 'Failed to load audit log');
    });
  }, []);

  if (error) return <Alert type="error" message={error} />;
  if (!data) return <LoadingSpinner text="Loading audit log…" />;

  return (
    <div>
      <header className="mb-6">
        <h2 className="text-xl font-bold tracking-tight text-ink-900 flex items-center gap-2">
          <ScrollText className="h-5 w-5 text-ink-500" /> Audit log
        </h2>
        <p className="mt-1 text-sm text-ink-500">{data.total} recorded action{data.total === 1 ? '' : 's'}.</p>
      </header>

      {data.logs.length === 0 ? (
        <div className="rounded-2xl border border-ink-200 bg-white p-10 text-center text-sm text-ink-500">
          No privileged actions recorded yet.
        </div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-ink-200 bg-white shadow-soft">
          <table className="min-w-full divide-y divide-ink-100 text-sm">
            <thead className="bg-ink-50">
              <tr className="text-left text-xs uppercase tracking-wider text-ink-500">
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">Actor</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Target</th>
                <th className="px-4 py-3">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-50">
              {data.logs.map((l) => (
                <tr key={l.id}>
                  <td className="px-4 py-3 text-ink-500 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3 text-ink-800">{l.actor_name || l.actor_id || '—'}</td>
                  <td className="px-4 py-3"><code className="text-xs bg-ink-100 rounded px-1.5 py-0.5">{l.action}</code></td>
                  <td className="px-4 py-3 text-ink-600">{l.target_type ? `${l.target_type}#${l.target_id}` : '—'}</td>
                  <td className="px-4 py-3 text-ink-500 font-mono text-xs max-w-xs truncate">{l.metadata ? JSON.stringify(l.metadata) : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditLog;
